import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'
import language from './modules/language'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: require('@/assets/sidebar-6.jpg'),
    drawer: false, /* Golf 2021-05-19 */
    showAppBar: true,
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SHOW_APP_BAR (state, payload) {
      state.showAppBar = payload
    },
    SET_DRAWER_WIDTH (state, val) {
      state.drawerWidth = val
    },
  },
  getters: {
    getShowAppBar: state => state.showAppBar,
    getAppBarHeight: state => state.appBarHeight,
  },
  actions: {

  },
  modules: {
    user,
    auth,
    language,
  },
  strict: debug,
})
